import { VerifyCollectionButton } from '../VerifyCollectionButton';

interface AppCollectionVerificationPromptProps {
  appData: {
    id: string;
    canManageNfts?: boolean;
    nftMintAddress: string | null;
    publisherNftMintAddress?: string | null;
    publisherWalletAddress?: string | null;
  } | null;
  isAppCollectionVerified: boolean | null;
  onVerificationSuccess: () => void;
}

export function AppCollectionVerificationPrompt({
  appData,
  isAppCollectionVerified,
  onVerificationSuccess,
}: AppCollectionVerificationPromptProps) {
  if (
    appData?.canManageNfts !== true ||
    !appData.nftMintAddress ||
    !appData.publisherNftMintAddress ||
    !appData.publisherWalletAddress ||
    isAppCollectionVerified !== false
  ) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-orange-900/20 to-yellow-900/20 rounded-xl p-6 mb-6 border border-orange-700/30">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
            <span className="animate-pulse size-2 bg-orange-400 rounded-full"></span>
            App Collection Verification Required
          </h3>
          <p className="text-sm text-neutral-300">
            This App NFT needs to be verified as part of the publisher
            collection.
          </p>
        </div>
        <VerifyCollectionButton
          dappId={appData.id}
          nftMintAddress={appData.nftMintAddress}
          collectionMintAddress={appData.publisherNftMintAddress}
          collectionAuthority={appData.publisherWalletAddress}
          verificationTarget="app"
          onSuccess={onVerificationSuccess}
          className="flex items-center gap-2"
          variant="secondary"
        />
      </div>
    </div>
  );
}
